import {AuthSource, AccountStateName, AccountBlockedCode} from 'enums';
import {Group} from 'interfaces';

import {UserParticipantRole} from './user-role.type';

export enum BaseUserRole {
    Agent = 'agent',
    Admin = 'admin',
    AppAdmin = 'app-admin'
}

export type UserSummary = {
    eid: number;
    email: string;
    firstName: string;
    lastName: string;
    activated?: boolean;
    inSessionRoles?: UserParticipantRole[];
}

export type User = UserSummary & {
    login?: string;
    roles: string[];
    middleName?: string
    title?: string;
    phone?: string;
    skype?: string;
    isAvailable: boolean;
    accountId: string;
    accountName?: string;
    accountStateName?: AccountStateName;
    accountStateData?: {
        code: AccountBlockedCode;
        message?: string;
    };
    groups: Group[];
    createdBy: number;
    createdAt: Date;
    passwordChangedAt: Date;
    // passwords required for profile
    password?: string;
    oldPassword?: string;
    confirmPassword?: string;
    // TODO: add typings for integrations
    integrations: {
        source: AuthSource;
        credentials: any;
        data: any;
    }[];
    mfaEmail?: {
        enabled: boolean;
        code?: number;
    }
    notifications: {
        enabled: boolean;
    }
}
